<div id="content-section">
  <div id="content-main" style="margin-right: 370px">
    <div id="content-sidebar" style="width: 350px; position: fixed; right: 20px">
      <h5 class="pt-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
        </div>
        Search&nbsp;&nbsp;
        <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? loadVendors() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
      </h5>
      <div class="clearfix"></div>
      <hr class="my-1" />
      <div class="row">
        <div class="col-md-12" id="search-form" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
          <div class="form-group">
            <label>Matter</label>
            <app-matter-search #matterSearch (clearMatter)="clearMatter()" (matter_id)="onMatterSelect($event)" [placeholder]="'Search by matter'" [small_input]="true"></app-matter-search>
          </div>
          <div class="form-group">
            <label>Vendor contact</label>
            <app-vendor-search #vendorSearch (clearVendor)="clearContact($event)" [small_input]="true" [data]="{ only_contact_name: true }" [include_item]="true" (vendor)="onContactSelect($event)"></app-vendor-search>
          </div>
          <div class="form-group row">
            <label class="col-12 col-form-label">Amount</label>
            <div class="col-3">
              <select name="amount_equality" [(ngModel)]="search_params.amount_equality" class="form-control form-control-sm">
                <option [value]="'='">=</option>
                <option [value]="'>'">&gt;</option>
                <option [value]="'<'">&lt;</option>
              </select>
            </div>
            <div class="col-9">
              <input type="number" placeholder="Amount" name="amount" [(ngModel)]="search_params.amount" min="0" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="search_params.hide_zero_balance = !search_params.hide_zero_balance">
              <input type="checkbox" class="custom-control-input" [(ngModel)]="search_params.hide_zero_balance" [checked]="search_params.hide_zero_balance" name="hide_zero_balance" />
              <label class="custom-control-label">Hide $0 balances</label>
            </div>
          </div>
          <div class="form-group">
            <label>Account #</label>
            <input type="text" placeholder="Account number" name="account_number" [(ngModel)]="search_params.account_number" class="form-control form-control-sm" />
          </div>
          <div class="form-group">
            <label>Chart of account</label>
            <select placeholder="chart of account" name="chart_of_account_id" [(ngModel)]="search_params.chart_of_account_id" class="form-control form-control-sm">
              <option *ngFor="let chart_of_account of search_options.chart_of_accounts" [value]="chart_of_account.value">{{ chart_of_account.label }}</option>
            </select>
          </div>
          <div class="form-group text-center">
            <button type="button" (click)="loadVendors()" [disabled]="searching" class="btn btn-primary btn-sm w-50">
              Search
              <span *ngIf="searching">&nbsp;</span>
              <i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Vendors</h2>
        <hr class="mt-1 mb-3" />
        <div class="sticky-top bg-light">
          <div class="py-1"></div>
          <div class="px-2">
            <div class="float-left pl-1">
              <app-pagination-count
                [count]="count"
                singularName="Vendor"
                pluralName="Vendors"
              ></app-pagination-count>
            </div>
            <div class="pull-right float-right">
              <pagination
                [boundaryLinks]="true"
                [maxSize]="5"
                [itemsPerPage]="search_options.per_page"
                [totalItems]="count"
                (pageChanged)="pageChanged($event)"
                [(ngModel)]="search_params.page"
                class="pagination-sm"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
              ></pagination>
            </div>
            <div class="pull-right float-right pr-5">
              <a class="btn btn-primary btn-sm" [routerLink]="'/vendors/new'"><i class="fas fa-plus-circle"></i>&nbsp;New Vendor</a>
            </div>
            <div class="clearfix"></div>
          </div>
          <hr class="mt-0 mb-1" />
        </div>
        <table class="table" *ngIf="count > 0">
          <thead>
            <tr>
              <th>Name</th>
              <th></th>
              <th>Account #</th>
              <th>Description</th>
              <th>Balance</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vendor of vendors">
              <td>
                <a title="View vendor information" [routerLink]="'/vendors/' + vendor.id">{{ vendor.contact_name }}</a>
              </td>
              <td>
                <a title="View contact" [href]="'/contacts/' + vendor.contact_id"><i class="fas fa-vcard-o"></i></a>
              </td>
              <td>
                <app-badge badgeType="info" classes="text-left" style="width: 100% !important" *ngIf="vendor.account_number">
                  {{ vendor.account_number }}
                </app-badge>
              </td>
              <td>
                {{ vendor.description }}
              </td>
              <td class="currency">
                {{ vendor.total_balance | currency: 'USD':'symbol-narrow':'1.2-2' }}
              </td>
              <td>
                <app-badge badgeType="success" *ngIf="vendor.is_auto_withdrawal">Auto W/D</app-badge>
                <span *ngIf="vendor.is_priority && vendor.is_auto_withdrawal">&nbsp;</span>
                <app-badge badgeType="danger" *ngIf="vendor.is_priority">Is a priority</app-badge>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="py-2"></div>
      </div>
    </div>
  </div>
</div>
